/* eslint-disable no-unused-vars */
export enum FunnelButtons {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}
